export default __webpack_public_path__ + "9c8778ce655ed62dbe5f024de551e79b.svg";